import { useEffect, useState } from 'react';
import apiPm from '../apiPm';

// Deliberately separate from AuthProvider's fetchCapabilities (which every
// module's login/init bootstrap goes through) — this is a small, isolated
// fetch scoped only to PM. If the Go PM API is slow/down/wrong, only the
// PM membership OR-condition degrades (falls back to the existing
// role-based Set Permission gate); every other module's auth bootstrap is
// completely unaffected. See NavLinks.jsx (menu visibility) and App.jsx's
// PmModuleRoute (route guard) for where this is consumed.
export const usePmProjectMembership = () => {
  const [isPmProjectMember, setIsPmProjectMember] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    apiPm.get('/v1/pm/members/me')
      .then((res) => {
        if (!cancelled) setIsPmProjectMember(Boolean(res.data?.isMember));
      })
      .catch(() => {
        if (!cancelled) setIsPmProjectMember(false);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  return { isPmProjectMember, loading };
};

export default usePmProjectMembership;
